__webpack_require__.p = "https://2022.igem.wiki/teccem/";